import { MetaProperty } from './meta-property';
import { DisplayModel } from './display-model';

export interface FieldListItem {
  path: string;
  label: string;
}

export class MetaClass {
  name: string;
  metaProperties: MetaProperty[];
  displayModel: DisplayModel;

  constructor() {}

  getFieldList(): FieldListItem[] {
    return this.recurseFields(this);
  }

  private recurseFields(
    meta: MetaClass,
    path: string[] = [],
    labelPrefix = ''
  ) {
    let fields: FieldListItem[] = [];

    if (!meta.displayModel) {
      return fields;
    }

    // Make list of displayed fields
    const displayedFields = new Set<string>();

    for (const group of meta.displayModel.groups) {
      for (const field of group.properties) {
        displayedFields.add(field.name);
      }
    }

    // Make fields list
    for (const property of meta.metaProperties) {
      if (property.metaClass) {
        fields = [
          ...fields,
          ...this.recurseFields(
            property.metaClass,
            [...path, property.name],
            `${labelPrefix}${property.label} `
          ),
        ];
      } else {
        if (!displayedFields.has(property.name)) {
          continue;
        }
        fields.push({
          path: [...path, property.name].join('.'),
          label: `${labelPrefix}${property.label}`,
        });
      }
    }
    return fields;
  }
}
